import { AbstractControl, ValidationErrors } from "@angular/forms";
import { IValidator } from "./IValidator";
import { AbstractValidator } from "./AbstractValidator";

import { Yii } from "libraries/interfaces/Yii";

export class MaxChars extends AbstractValidator implements IValidator {

    public constructor(
        private readonly testValue: AbstractControl,
        private readonly max: number,
    ) {
        super({
            maxChars: {
                when: 'touched',
                message: Yii.t('wui-shared-js', 'Le nombre de caractères max : ') + max,
            },
        });
    }

    public validate(): ValidationErrors | null {
        return this.testValue.value.length > this.max ? { maxChars: true } : null;
    }
}
